import React, { useEffect, useState } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Select from "react-select";

import { GetUser, GetAllUsers, UpdateUsers } from '../../../services/auth-service/authService';
import axios from 'axios';

import useEnhancedEffect from "@mui/material/utils/useEnhancedEffect";

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function ApprovelForm() {

    const [dropdownlist, setdropdownlist] = useState([]);
    const [isstatus, setisstatus] = useState(true);
    const [formData, setFormData] = useState({
        user_id:'',
        employee_no: '',
        name: '',
        username: '',
        
        email: '',
        mobile_number: '',
        designation: '',
        department: '',
        reporting_manager: '',
    });

    const [selectedEmployee, setSelectedEmployee] = useState(null);

    const getUsersData = (selectedOption) => {
        let payload = { 'id': selectedOption.value };
        var getFileUploadsList = GetUser();

        axios.post(getFileUploadsList[1], payload, getFileUploadsList[0])
            .then(
                response => {
                    console.log("get user data!!!", response);
                    // let response = response.json();
                    let userData = response.data;
                    const [user] = userData;
                    console.log('data', user.status);
                    let status = user.status;
                    if (status) {
                        setisstatus(false);
                    }
                    setFormData({
                        user_id: user.user_id || '',
                        employee_no: user.employee_no || '',
                        name: user.name || '',
                        username: user.username || '',
                        email: user.email || '',
                        mobile_number: user.mobile_number || '',
                        designation: user.designation || '',
                        department: user.department || '',
                        reporting_manager: user.reporting_manager || '',
                    });
                }
            ).catch(
                error => {
                    console.log("Error in store user data!!!", error);

                }
            );
    }

    const handleEmployeeSelect = (selectedOption) => {
        setSelectedEmployee(selectedOption);
        getUsersData(selectedOption);
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };


    useEffect(() => {

        let payload = { 'hi': 'hi' };
        var getFileUploadsList = GetAllUsers();

        axios.get(getFileUploadsList[1], payload, getFileUploadsList[0])
            .then(
                response => {
                    console.log("get all user data!!!", response);
                    // let response = response.json();
                    let data1 = response.data;
                    let data = data1.data_out;
                    let names = [];
                    data.map((data) => {
                        let obj = {
                            value: data.user_id,
                            label: data.name
                        }
                        names.push(obj);
                    });
                    console.log('names', names);
                    // setTargetOptions(names);
                    setdropdownlist(names);
                }
            ).catch(
                error => {
                    console.log("Error in store user data!!!", error);

                }
            );

    }, []);


    const handleSubmit = (val) => {
        let payload = formData;
        payload['status'] = val;
        console.log('payload', payload);

    var getFileUploadsList = UpdateUsers();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("updated user data!!!", response);         
                
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );
    };

    const handleSubmit1 = (val) => {
        let payload = formData;
        payload['is_active'] = val;
        console.log('payload', payload);

    var getFileUploadsList = UpdateUsers();

    axios.post(getFileUploadsList[1],  payload, getFileUploadsList[0])
        .then(
            response => {
                console.log("updated user data!!!", response);         
                
            }
        ).catch(
            error => {
                console.log("Error in store user data!!!", error);
        
            }
        );
    };

    const handleapprove = () =>{
        console.log('approved');
        handleSubmit('approved')
    }

    const handlereject = () =>{
        handleSubmit('rejected')
    }

    const handleactivate = () =>{
        
        handleSubmit1(1);
    }

    const handledeactivate = () =>{
        handleSubmit1(0);
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs" style={{backgroundColor: 'rgb(233, 232, 217);'}}>
                <CssBaseline />
                <Box
                    sx={{
                        
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Approvel Form
          </Typography> */}
                    <Box component="form" noValidate sx={{ mt: 3 }} style={{backgroundColor:'white', padding:'1em'}}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div className="dropdown-container1" style={{width:'12em'}}>
                                    <Select
                                        clearable
                                        selection
                                        placeholder='Choose id'
                                        size='mini'
                                        options={dropdownlist}
                                        onChange={handleEmployeeSelect}
                                        value={selectedEmployee}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    autoComplete="given-name"
                                    name="name"
                                    required
                                    fullWidth
                                    id="name"
                                    label="Name"
                                    autoFocus
                                    value={formData.name}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    fullWidth
                                    id="username"
                                    label="User Name"
                                    name="username"
                                    autoComplete="user-name"
                                    value={formData.username}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField

                                    name="employee_no"
                                    required
                                    fullWidth
                                    id="employee_no"
                                    label="EmpNo"
                                    autoComplete="employee_no"
                                    value={formData.employee_no}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email Address"
                                    name="email"
                                    autoComplete="email"
                                    value={formData.email}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    name="mobile_number"
                                    label="mobile_number"
                                    type="mobile_number"
                                    id="mobile_number"
                                    autoComplete="new-mobileno"
                                    value={formData.mobile_number}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField

                                    fullWidth
                                    name="designation"
                                    label="designation"
                                    type="designation"
                                    id="designation"
                                    autoComplete="new-designation"
                                    value={formData.designation}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    name="department"
                                    label="department"
                                    type="department"
                                    id="department"
                                    autoComplete="new-department"
                                    value={formData.department}
                                    onChange={handleFormChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    name="reporting_manager"
                                    label="reporting_manager"
                                    type="reporting_manager"
                                    id="reporting_manager"
                                    autoComplete="new-reporting_manager"
                                    value={formData.reporting_manager}
                                    onChange={handleFormChange}
                                />
                            </Grid>

                            {isstatus ? (
                                // Render these buttons when isstatus is true
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={handleapprove}
                                        >
                                            Approve
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={handlereject}
                                        >
                                            Reject
                                        </Button>
                                    </Grid>
                                </>
                            ) : (
                                // Render these buttons when isstatus is false
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={handleactivate}
                                        >
                                            Activate
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                        
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2 }}
                                            onClick={handledeactivate}
                                        >
                                            Deactivate
                                        </Button>
                                    </Grid>
                                </>
                            )}

                        </Grid>


                    </Box>
                </Box>

            </Container>
        </ThemeProvider>
    );
}